module.exports = __webpack_public_path__ + "img/青とピンク 歯 痛み クリーン 情報 健康 衛生 歯医者 Instagram投稿.447b8e80.png";